<template>
  <div class="inline-block">
    <action-icons
      :icon="starToShow(i)"
      class="w-4 h-4 inline"
      :class="rating ? 'cursor-pointer hover:text-main' : ''"
      :key="`star-${i}`"
      v-for="i in 5" @click.native="selectStar(i)"/>
    <input type="hidden" name="rating" value="1" v-model="userRating">
  </div>
</template>
<script>
export default {
  name: 'rate-stars',
  props: {
    rate: {
      type: Number,
      default: 0
    },
    rating: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filledStars: 0,
      emptyStars: 0,
      actualRate: 0,
      userRating: 1,
    }
  },
  mounted() {
    if (this.rating) {
      this.actualRate = 1;
    } else {
      this.actualRate = this.rate;
    }
  },
  methods: {
    selectStar(star) {
      if (!this.rating) {
        return;
      }

      this.actualRate = star;
      this.userRating = star;
    },
    starToShow(star) {
      if (star <= this.actualRate) {
        return 'star-full'
      } else {
        if (this.actualRate % 1 != 0 && Math.ceil(this.actualRate) == star) {
          return 'star-half';
        } else {
          return 'star-empty';
        }
      }
    }
  }
}
</script>